import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { IconButton, Tooltip, Typography } from '@mui/material';
import styles from './ActivePatrolDrawer.module.css';
import {
	ArrowBackIcon,
	CameraIcon,
	ClearIcon,
	UploadIcon,
} from 'components/icons';
import UppyDashboardModalGuard from '../uppy/UppyDashboardModalGuard';
import { useActivePatrolData } from '../../context/activePatrol/ActivePatrolDataProvider';
import { useActivePatrolLogic } from '../../context/activePatrol/ActivePatrolLogicProvider';
import { useActivePatrolUI } from '../../context/activePatrol/ActivePatrolUIProvider';

interface ActivePatrolDrawerHeaderProps {
	// Define your props here
}

const ActivePatrolDrawerHeader: React.FC<ActivePatrolDrawerHeaderProps> = (
	props,
) => {
	const { setShowDrawer } = useActivePatrolUI();
	const { activePatrolDataRef, uppyPatrol } = useActivePatrolData();
	const { attemptExitPatrol } = useActivePatrolLogic();

	const [uploadModalOpen, setUploadModalOpen] = useState<boolean>(false);

	const handleUploadModalOpen = () => {
		setUploadModalOpen(true);
	};
	const handleUploadModalClose = () => {
		setUploadModalOpen(false);
	};
	const handleMinimizePatrol = () => {
		setShowDrawer(false);
	};

	return (
		<>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				<Box className={styles.itemContainer}>
					<IconButton onClick={handleMinimizePatrol}>
						<ArrowBackIcon />
					</IconButton>
					<Typography variant="body1" className={styles.locationText}>
						<span className={styles.customer}>
							{activePatrolDataRef.current?.patrolInfo.cust_name}
						</span>
						{' - '}
						{activePatrolDataRef.current?.patrolInfo.address}
					</Typography>
				</Box>
				<Box>
					<Box className={styles.buttonContainer}>
						<Tooltip title="Upload Files">
							<IconButton onClick={handleUploadModalOpen}>
								<UploadIcon />
							</IconButton>
						</Tooltip>
						{/* <Tooltip title="Upload Image">
							<IconButton>
								<CameraIcon />
							</IconButton>
						</Tooltip> */}
						<Tooltip title="Close">
							<IconButton onClick={attemptExitPatrol}>
								<ClearIcon />
							</IconButton>
						</Tooltip>
					</Box>
				</Box>
			</Box>
			<UppyDashboardModalGuard
				uppy={uppyPatrol}
				openDashboard={uploadModalOpen}
				onCloseDashboard={handleUploadModalClose}
			/>
		</>
	);
};

export default ActivePatrolDrawerHeader;
